import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface KeyMetrics {
  symbol: string;
  date: string;
  fiscalYear: string;
  period: string;
  reportedCurrency: string;
  marketCap: number;
  enterpriseValue: number;
  evToSales: number;
  evToOperatingCashFlow: number;
  evToFreeCashFlow: number;
  evToEBITDA: number;
  netDebtToEBITDA: number;
  currentRatio: number;
  incomeQuality: number;
  grahamNumber: number;
  grahamNetNet: number;
  taxBurden: number;
  interestBurden: number;
  workingCapital: number;
  investedCapital: number;
  returnOnAssets: number;
  operatingReturnOnAssets: number;
  returnOnTangibleAssets: number;
  returnOnEquity: number;
  returnOnInvestedCapital: number;
  returnOnCapitalEmployed: number;
  earningsYield: number;
  freeCashFlowYield: number;
  capexToOperatingCashFlow: number;
  capexToDepreciation: number;
  capexToRevenue: number;
  salesGeneralAndAdministrativeToRevenue: number;
  researchAndDevelopementToRevenue: number;
  stockBasedCompensationToRevenue: number;
  intangiblesToTotalAssets: number;
  averageReceivables: number;
  averagePayables: number;
  averageInventory: number;
  daysOfSalesOutstanding: number;
  daysOfPayablesOutstanding: number;
  daysOfInventoryOutstanding: number;
  operatingCycle: number;
  cashConversionCycle: number;
  freeCashFlowToEquity: number;
  freeCashFlowToFirm: number;
  tangibleAssetValue: number;
  netCurrentAssetValue: number;
}

export const useCompanyKeyMetrics = (
  ticker: string,
  limit?: number,
  period?: 'annual' | 'quarter'
) => {
  return useQuery<KeyMetrics[], Error>({
    queryKey: ['companyKeyMetrics', ticker, limit, period],
    queryFn: async () => {
      const params: Record<string, string | number> = { ticker };
      if (limit) params.limit = limit;
      if (period) params.period = period;
      const { data } = await api.get<KeyMetrics[]>('/company-key-metrics', { params });
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 2.5 * 60 * 1000,
    retry: (failureCount, error) => {
      if ((error as { response?: { status?: number } })?.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
};
